module.exports = __webpack_public_path__ + "img/blog3.2d5a94f7.jpg";